import { useState } from 'react';
import { toast } from 'sonner';

import { useDownloadParcelLabelMutation } from '@/graphql/mutations/downloadParcelLabel.generated';
import i18n from '@/utils/i18n';

// Downloads ONE parcel's label and opens it in a new tab. The order-wide
// document download merges every label the order has, which is the wrong sheet
// to hand a warehouse after a partial replacement — there it would reprint the
// parcels already in the post alongside the one that was actually replaced.
export function useDownloadParcelLabel(orderId: string) {
  const [downloadParcelLabel] = useDownloadParcelLabelMutation();
  // Per parcel rather than one flag, so only the row that was clicked shows a
  // spinner while the others stay clickable.
  const [pendingParcelId, setPendingParcelId] = useState<string | null>(null);

  const handleDownloadParcelLabel = async (parcelId: string) => {
    setPendingParcelId(parcelId);
    try {
      const response = await downloadParcelLabel({
        variables: { order_id: orderId, parcel_id: parcelId },
      });
      const url = response.data?.downloadParcelLabel?.label_url;
      if (!url) {
        toast.error(i18n.t('Order:toastDownloadParcelLabelError'));
        return;
      }
      window.open(url, '_blank');
    } catch {
      toast.error(i18n.t('Order:toastDownloadParcelLabelError'));
    } finally {
      setPendingParcelId(null);
    }
  };

  return { handleDownloadParcelLabel, pendingParcelId };
}
